import { isEmpty } from 'lodash'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

import { Theme, Typography } from '@mui/material'

import BulletPoint from '../BulletPoint'

type CompanyInvestorsViewListProps = {
  investorsTypeLabel: string
  investors: string[]
}

export const CompanyInvestorsViewList = React.memo(
  ({ investorsTypeLabel, investors }: CompanyInvestorsViewListProps) => {
    const { classes } = useStyles()

    if (isEmpty(investors)) {
      return null
    }

    return (
      <>
        <BulletPoint
          className={classes.bulletPoint}
          item={
            <>
              <Typography className={classes.bulletPointTitle} variant="body2">
                {investorsTypeLabel}
              </Typography>
            </>
          }
        />
        <div className={classes.investorList}>
          {investors.map((investor) => (
            <Typography className={classes.description} key={investor} variant="body2">
              {investor}
            </Typography>
          ))}
        </div>
      </>
    )
  }
)

CompanyInvestorsViewList.displayName = 'CompanyInvestorsViewList'

const useStyles = makeStyles()(({ spacing }: Theme) => ({
  bulletPoint: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  bulletPointTitle: {
    fontWeight: 'bold',
  },
  investorList: {
    display: 'flex',
    flexDirection: 'column',
    paddingLeft: spacing(5),
  },
  description: {
    marginBottom: spacing(),
  },
}))
